import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
export class WidgetContact {
  name: string; // 9,
  email: string; // 9,
  message: string; // "basketball",
  subject: string; // "basketball",
}
@Component({
  name: 'bpc-widget-contact-form',
  components: {},
})
export default class WidgetForm extends Vue {
  @Prop(Boolean) readonly showSubject: boolean;
  @Prop(String) readonly emailTo: string;

  public toSend: WidgetContact = new WidgetContact();
  public wellSent = false;

  onClickSendEmail() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('widgets');
    if (!this.toSend.subject || !this.showSubject) {
      this.toSend.subject = this.$t('global.widget.default_subject').toString();
    }
    this.$bpcApi
      .post(
        basePath + '/send-email',
        {
          content: this.toSend,
          emailTo: this.emailTo,
        },
        {},
        'public',
      )
      .subscribe(
        res => {
          this.toSend = new WidgetContact();
          this.wellSent = true;
        },
        error => {
          console.log(error);
          this.toSend = new WidgetContact();
          this.wellSent = false;
        },
      );
  }
}
